import React from 'react';
import UserInfo from '../../Components/User/UserInfo';
import TopTitleBlock from '../../Components/TopTitleBlock/TopTitleBlock';
import CalculatedTable from '../../Components/TableCommonDirectory/AccountsTable/CalculatedTable';
import {useTranslation} from 'react-i18next';
import TopPageInfoBlock from '../../Components/TopPageInfoBlock/TopPageInfoBlock';
import {monthNow} from '../../assets/utils/dateUtils';
import SumBonusBlock from './components/SumBonusBlock';
//import BillingAccount from './components/BillingAccount';
//import BillingPremia from './components/BillingPremia';
import {
	useGetBillingCashbackQuery,
	useGetBillingOptimaQuery,
	useGetBillingPointSmpQuery,
} from '../../redux/userBillingApi';
import PreLoaderComponent from '../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import {RequestPremiaType} from '../../types/TypesUserAccounts';
//import BillingActions from './components/BillingActions';
import {useStatusRestriction} from '../../hooks/useStatusRestriction';
import StatusRestrictionMessage from '../../Components/StatusRestrictionMessage/StatusRestrictionMessage';
import s from './MyAccounts.module.css';

const MyAccounts: React.FC = () => {
	const {t} = useTranslation();
	const restrictions = useStatusRestriction();
	const [filtersOptima, setFiltersOptima] = React.useState<RequestPremiaType>({
		month: monthNow(),
	});
	const [filtersCashback, setFiltersCashback] =
		React.useState<RequestPremiaType>({
			month: monthNow(),
		});
	const [filtersPointSmp, setFiltersPointSmp] = React.useState<{month: string}>(
		{
			month: monthNow(),
		},
	);

	// Ref для отслеживания скролла к таблицам
	const [shouldScrollOptima, setShouldScrollOptima] = React.useState(false);
	const [shouldScrollCashback, setShouldScrollCashback] = React.useState(false);
	const [shouldScrollPointSmp, setShouldScrollPointSmp] = React.useState(false);
	const {data: billingOptima, isLoading: isLoadingOptima} =
		useGetBillingOptimaQuery(filtersOptima, {
			skip:
				!restrictions.canAccessPartnerIncomePage ||
				!restrictions.canShowPremiaBlock,
		});
	const {data: billingCashback, isLoading: isLoadingCashback} =
		useGetBillingCashbackQuery(filtersCashback, {
			skip:
				!restrictions.canAccessPartnerIncomePage ||
				!restrictions.canShowCashbackBlock,
		});
	const {data: billingPointSmp, isLoading: isLoadingPointSmp} =
		useGetBillingPointSmpQuery(filtersPointSmp, {
			skip:
				!restrictions.canAccessPartnerIncomePage ||
				!restrictions.canShowPremiaBlock,
		});

	// Callbacks для скролла - устанавливаем флаг скролла при применении фильтра
	const handleFilterAppliedOptima = () => {
		setShouldScrollOptima(true);
	};
	const handleFilterAppliedCashback = () => {
		setShouldScrollCashback(true);
	};
	const handleFilterAppliedPointSmp = () => {
		setShouldScrollPointSmp(true);
	};

	// Сбрасываем флаги скролла после выполнения
	const handleScrolledOptima = () => {
		setShouldScrollOptima(false);
	};
	const handleScrolledCashback = () => {
		setShouldScrollCashback(false);
	};
	const handleScrolledPointSmp = () => {
		setShouldScrollPointSmp(false);
	};

	if (!restrictions.canAccessPartnerIncomePage) {
		return (
			<div className={`page__content ${s.pageContent}`}>
				<StatusRestrictionMessage message={t('Сторінка недоступна')} />
			</div>
		);
	}

	return (
		<div className={`page__content ${s.pageContent}`}>
			{/*<PopupsTemplate />*/}
			<TopTitleBlock title={t('Мій партнерський дохід')} />
			<div className="page__user user">
				<div className="user__row">
					<div className="user__column">
						<UserInfo />
					</div>
					<div className="user__column">
						<SumBonusBlock />
					</div>
				</div>
			</div>
			{/*<div className="page__accounts accounts">
				<div className="accounts__row">
					<div className="accounts__column">
						<BillingAccount />
					</div>
					<div className="accounts__column">
						<BillingActions />
					</div>
				</div>
			</div>*/}
			{/*{restrictions.canShowPremiaBlock && <BillingPremia />}*/}
			{!restrictions.canShowNetworkIncome && (
				<StatusRestrictionMessage message={t("Тут з'явиться інформація коли ви зареєструєте клієнтів в свою мережу.")} />
			)}
			{restrictions.canShowNetworkIncome && (
				<TopPageInfoBlock
					text={t(
						'Мій партнерський дохід — це загальна сума всіх винагород, які ви отримуєте від співпраці з компанією CHOICE:\n',
					)}
					subText={t(
						'І він складається з:\n' +
							'1) Дохід від побудови власної мережі\n' +
							'2) Дохід CashBack \n' +
							'3) Дохід за програмою OPTIMA\n',
					)}
				/>
			)}
			{/* 1. Дохід від побудови власної мережі */}
			{restrictions.canShowCashbackBlock && isLoadingPointSmp ? (
				<PreLoaderComponent type={'circle'} size={'big'} />
			) : (
				restrictions.canShowCashbackBlock &&
				billingPointSmp && (
					<CalculatedTable
						setFilters={setFiltersPointSmp}
						title={t('Дохід від побудови власної мережі')}
						buttonName={t('Нараховано цього місяця')}
						type={'PersonalVolume'}
						data={billingPointSmp}
						shouldScroll={shouldScrollPointSmp}
						onScrolled={handleScrolledPointSmp}
						onFilterApplied={handleFilterAppliedPointSmp}
					/>
				)
			)}
			{/* 2. Дохід CashBack */}
			{restrictions.canShowCashbackBlock && isLoadingCashback ? (
				<PreLoaderComponent type={'circle'} size={'big'} />
			) : (
				restrictions.canShowCashbackBlock &&
				billingCashback && (
					<CalculatedTable
						setFilters={setFiltersCashback}
						title={t('Дохід CashBack')}
						buttonName={t('Архів Cashback')}
						type={'Cashback'}
						data={billingCashback}
						shouldScroll={shouldScrollCashback}
						onScrolled={handleScrolledCashback}
						onFilterApplied={handleFilterAppliedCashback}
					/>
				)
			)}
			{/* 3. Дохід за програмою OPTIMA */}
			{restrictions.canShowPremiaBlock && isLoadingOptima ? (
				<PreLoaderComponent type={'circle'} size={'big'} />
			) : (
				restrictions.canShowPremiaBlock &&
				billingOptima && (
					<CalculatedTable
						setFilters={setFiltersOptima}
						title={t('Дохід за програмою Optima')}
						buttonName={t('ВСІ OPTIMA')}
						type={'OPTIMA'}
						data={billingOptima}
						shouldScroll={shouldScrollOptima}
						onScrolled={handleScrolledOptima}
						onFilterApplied={handleFilterAppliedOptima}
					/>
				)
			)}
		</div>
	);
};

export default MyAccounts;
